import React from 'react';

import ButtonBase from './button-base';
import { BaseButtonProps } from './types';

/**
 * IMPORTANT: Specify `next` or `prev` as _(or as part of)_ the `className`
 * property so the correct button orientation will be used.
 */
/**
 * Returns an instance of a CalendarNavigationButton.
 *
 * @param className - Class name(s) to apply.
 * <b>Important:</b> Specify `next` or `prev` as _(or as part of)_ the `className`
 * property so the correct button orientation will be used.
 * @param disabled - If true, sets `disabled` property on the button.
 * @param id - The value to set for the `id` property.
 * @param name - The value to set for the `name` property.
 * @param onClick - The callback handler for the click event.
 * @param value - Value to set on the button.
 * @param type - Button type.
 * @returns JSX.Element.
 *
 * @example
 *
 * ```typescriptreact
 * <CalendarNavigationButton
 *   className="next"
 *   value={}
 * />
 * ```
 */
export function CalendarNavigationButton({ className, disabled, id, name, onClick, value, ...props }: BaseButtonProps) {
  return (
    <ButtonBase
      className={`calendar-navigation-button ${className ? `${className}` : ''}`}
      disabled={disabled}
      id={id}
      name={name}
      onClick={onClick}
      title={value}
      value={value}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
